import { motion } from 'framer-motion';

const Bat = ({ size = 32, flap = 0.35 }) => (
  <svg
    viewBox="0 0 64 48"
    width={size}
    height={size * 0.75}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <motion.path
      initial={false}
      animate={{
        d: [
          'M32 24 C 24 10, 12 6, 4 16 C 10 18, 14 22, 16 28 C 20 22, 26 22, 32 28 C 38 22, 44 22, 48 28 C 50 22, 54 18, 60 16 C 52 6, 40 10, 32 24 Z',
          'M32 24 C 22 20, 10 22, 2 30 C 10 28, 14 28, 16 32 C 22 26, 26 26, 32 30 C 38 26, 42 26, 48 32 C 50 28, 54 28, 62 30 C 54 22, 42 20, 32 24 Z',
          'M32 24 C 24 10, 12 6, 4 16 C 10 18, 14 22, 16 28 C 20 22, 26 22, 32 28 C 38 22, 44 22, 48 28 C 50 22, 54 18, 60 16 C 52 6, 40 10, 32 24 Z',
        ],
      }}
      transition={{ duration: flap, repeat: Infinity, ease: 'easeInOut' }}
      fill="#0b0b16"
    />
    {/* corps */}
    <ellipse cx="32" cy="26" rx="3" ry="5" fill="#0b0b16" />
    {/* oreilles */}
    <polygon points="30,19 31,14 33,18" fill="#0b0b16" />
    <polygon points="34,19 33,14 31,18" fill="#0b0b16" />
    {/* yeux rouges */}
    <circle cx="30.5" cy="24" r="0.7" fill="#ff2d2d" />
    <circle cx="33.5" cy="24" r="0.7" fill="#ff2d2d" />
  </svg>
);

const BATS = [
  { id: 'b1', top: '14%', size: 36, delay: 0, duration: 22, flap: 0.3, dir: 1, yAmp: 40 },
  { id: 'b2', top: '28%', size: 26, delay: 3, duration: 28, flap: 0.28, dir: -1, yAmp: 60 },
  { id: 'b3', top: '48%', size: 42, delay: 6, duration: 25, flap: 0.34, dir: 1, yAmp: 50 },
  { id: 'b4', top: '62%', size: 22, delay: 1.5, duration: 30, flap: 0.26, dir: -1, yAmp: 30 },
  { id: 'b5', top: '78%', size: 32, delay: 4.5, duration: 24, flap: 0.32, dir: 1, yAmp: 45 },
];

export const HalloweenBats = () => (
  <div
    aria-hidden="true"
    data-testid="halloween-bats"
    className="pointer-events-none fixed inset-0 z-[9] overflow-hidden"
  >
    {BATS.map((b) => (
      <motion.div
        key={b.id}
        className="absolute"
        style={{ top: b.top, left: b.dir === 1 ? '-80px' : 'auto', right: b.dir === -1 ? '-80px' : 'auto' }}
        initial={{ x: 0, y: 0 }}
        animate={{
          x: b.dir === 1 ? ['0vw', '110vw'] : ['0vw', '-110vw'],
          y: [0, -b.yAmp, b.yAmp / 2, -b.yAmp / 2, 0],
          rotate: [-6, 4, -3, 5, -6],
        }}
        transition={{
          x: { duration: b.duration, repeat: Infinity, delay: b.delay, ease: 'linear' },
          y: { duration: b.duration / 2, repeat: Infinity, delay: b.delay, ease: 'easeInOut' },
          rotate: { duration: b.duration / 3, repeat: Infinity, delay: b.delay, ease: 'easeInOut' },
        }}
      >
        <div style={{ filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.5))' }}>
          <Bat size={b.size} flap={b.flap} />
        </div>
      </motion.div>
    ))}
  </div>
);
